// DashKPICard — Big number + uppercase label + subtitle
// Corporate card style with top accent border

import { DASH_KPI_CARD, C } from './dashboardStyles';

interface DashKPICardProps {
  value: string;
  label: string;
  subtitle?: string;
}

export function DashKPICard({ value, label, subtitle }: DashKPICardProps) {
  return (
    <div style={DASH_KPI_CARD}>
      <div style={{ fontSize: 30, fontWeight: 700, color: C.azul1, lineHeight: 1.1 }}>{value}</div>
      <div
        style={{
          fontSize: 10,
          fontWeight: 600,
          color: C.grisOscuro,
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          marginTop: 8,
        }}
      >
        {label}
      </div>
      {subtitle && <div style={{ fontSize: 9, color: '#aaa', marginTop: 3 }}>{subtitle}</div>}
    </div>
  );
}
